import ClearIcon from '@mui/icons-material/Clear';
import DoneIcon from '@mui/icons-material/Done';
import EditIcon from '@mui/icons-material/Edit';
import { Box, IconButton, styled, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';

interface Props {
  fileName: string;
  onDeleteFile?: () => void;
  onEditFile?: (fileName: string) => void;
  onClickFile?: () => void;
}

const CustomBox = styled('div')(({ theme }) => ({
  border: '1px solid #DDDDDD',
  borderRadius: '3px',
  width: '270px',
  height: '48px',
  backgroundColor: '#F6F7FB',
  padding: theme.spacing(1, 2, 1, 2),
  marginBottom: theme.spacing(1),
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1
}));

const AttachmentBox = (props: Props): JSX.Element => {
  const [editable, setEditable] = useState<boolean>(false);
  const [fileName, setFileName] = useState<string>(
    props.fileName.split('.')[0]
  );
  const [fileType] = useState<string>(props.fileName.split('.')[1]);

  const onEditFile = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    if (props.onEditFile) {
      props.onEditFile(`${fileName}.${fileType}`);
      triggerEdit(event);
    }
  };

  const onDeleteFile = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    if (props.onDeleteFile) {
      props.onDeleteFile();
    }
  };

  const triggerEdit = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setEditable((prevState) => !prevState);
  };

  return (
    <CustomBox
      sx={{
        position: 'relative',
        pr: props.onDeleteFile ? (props.onEditFile ? 9 : 4) : 2
      }}
    >
      {!editable && (
        <Box onClick={props.onClickFile}>
          <Typography color="primary" noWrap>
            {props.fileName}
          </Typography>
          {props.onEditFile && (
            <Box sx={{ position: 'absolute', right: 36, top: 6 }}>
              <IconButton size="small" onClick={triggerEdit}>
                <EditIcon fontSize="small" />
              </IconButton>
            </Box>
          )}
          {props.onDeleteFile && (
            <Box sx={{ position: 'absolute', right: 2, top: 6 }}>
              <IconButton size="small" onClick={onDeleteFile}>
                <ClearIcon fontSize="small" />
              </IconButton>
            </Box>
          )}
        </Box>
      )}
      {editable && (
        <>
          <TextField
            variant="standard"
            value={fileName}
            onChange={(event) => {
              setFileName(event.target.value);
            }}
          />

          <Box sx={{ position: 'absolute', right: 36, top: 6 }}>
            <IconButton size="small" onClick={onEditFile}>
              <DoneIcon fontSize="small" />
            </IconButton>
          </Box>

          <Box sx={{ position: 'absolute', right: 2, top: 6 }}>
            <IconButton size="small" onClick={triggerEdit}>
              <ClearIcon fontSize="small" />
            </IconButton>
          </Box>
        </>
      )}
    </CustomBox>
  );
};

export default AttachmentBox;
